import style from "./ItemFormWrapper.module.css";

export const ItemFormWrapper = ({
  children,
  onBack,
  onContinue,
  continueText,
  bg,
  padding,
  disabled,
  secondaryAction,
  secondaryText,
  secondaryDisabled,
}) => {
  return (
    <div className={style.wrapper}>
      <div
        className={style.formWrapper}
        style={{ backgroundColor: bg, padding }}
      >
        {children}
      </div>
      <div className={style.buttonsWrapper}>
        {onBack ? (
          <button onClick={onBack} className={style.backButton}>
            Back
          </button>
        ) : (
          <div />
        )}
        <div className={style.rightButtons}>
          {!!secondaryAction && (
            <button
              onClick={secondaryAction}
              className={style.secondaryButton}
              disabled={secondaryDisabled}
            >
              {secondaryText || "Secondary"}
            </button>
          )}
          {onContinue ? (
            <button
              onClick={() => {
                onContinue();
              }}
              className={style.continueButton}
              disabled={disabled}
            >
              {continueText || "Continue"}
            </button>
          ) : (
            <div />
          )}
        </div>
      </div>
    </div>
  );
};
